// extracted by mini-css-extract-plugin
module.exports = {"category":"show-card_category__1Zna_","text":"show-card_text__2T2Q1","media":"show-card_media__1Kp01"};